import React, { createContext, useContext } from "react";
import {
  SCHEDULE_APPOINTMENT,
  ACCEPT_APPOINTMENT,
  CANCEL_APPOINTMENT,
  GET_APPOINTEMENTS_BY_FILTERS,
  GET_MY_APPOINTMENTS,
  GET_LAWYER_TIME_BLOCKERS,
} from "../helpers/UrlConstants";
import axiosFactory, { METHOD_POST, METHOD_GET } from "../helpers/AxiosFactory";

const AppointmentContext = createContext();
export function useAppointmentContext() {
  return useContext(AppointmentContext);
}
export default function AppointmentProvider({ children }) {
  async function getMyAppointements() {
    return await axiosFactory({
      url: GET_MY_APPOINTMENTS,
      method: METHOD_GET,
    });
  }
  async function getMyAppointementsByFilter(data) {
    return await axiosFactory({
      url: GET_APPOINTEMENTS_BY_FILTERS,
      method: METHOD_POST,
      data: data,
    });
  }
  async function scheduleAppointment(data) {
    return await axiosFactory({
      url: SCHEDULE_APPOINTMENT,
      method: METHOD_POST,
      data: data,
    });
  }
  async function acceptAppointment(data) {
    return await axiosFactory({
      url: ACCEPT_APPOINTMENT,
      method: METHOD_POST,
      data: data,
    });
  }
  async function cancelAppointment(data) {
    return await axiosFactory({
      url: CANCEL_APPOINTMENT,
      method: METHOD_POST,
      data: data,
    });
  }
  async function getLawyerTimeBlockers(data) {
    return await axiosFactory({
      url: GET_LAWYER_TIME_BLOCKERS,
      method: METHOD_POST,
      data: data,
    });
  }
  const value = {
    scheduleAppointment,
    acceptAppointment,
    cancelAppointment,
    getMyAppointements,
    getMyAppointementsByFilter,
    getLawyerTimeBlockers,
  };
  return (
    <AppointmentContext.Provider value={value}>
      {children}
    </AppointmentContext.Provider>
  );
}
